import { combineReducers } from 'redux';

import comments from './comments';
import reviewReasons from './reviewReasons';
import reviews, * as fromReviews from './reviews';
import completedReviews from './completedReviews';

export default combineReducers({
  comments,
  completedReviews,
  reviews,
  reviewReasons,
});

export const selectComments = state => state.comments;
export const selectReviews = state => state.reviews;
export const selectReviewReasons = state => state.reviewReasons;
export const selectCompletedReviews = state => state.completedReviews;

export const selectReview = (state, id) => fromReviews.selectReview(selectReviews(state), id);
